"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThrottleTime = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const useThrottleTime = (callback, isActive, timeout = 200, config) => {
    const valueSubjectRef = (0, react_1.useRef)(new rxjs_1.Subject());
    const resultCallbackRef = (0, react_1.useRef)((...args) => {
        valueSubjectRef.current.next(args);
    });
    (0, react_1.useEffect)(() => {
        if (isActive) {
            const subscription = valueSubjectRef.current
                .pipe((0, operators_1.throttleTime)(timeout, rxjs_1.asyncScheduler, config))
                .subscribe((args) => callback(...args));
            return () => {
                subscription.unsubscribe();
            };
        }
        return;
    }, [callback, config, isActive, timeout]);
    return resultCallbackRef.current;
};
exports.useThrottleTime = useThrottleTime;
//# sourceMappingURL=useThrottleTime.js.map